// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.CompanyNameMatching')
class Toolbox__CompanyNameMatching {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "none" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["resolutions", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["resolutions", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["resolutions", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "resolutions": "Toolbox.CompanyNameResolution[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ resolutions: () => Toolbox.CompanyNameResolution } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θresolutions = Signals.proxySignalDeferred<Toolbox.CompanyNameResolution[]>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.CompanyNameMatching' {
        return 'Toolbox.CompanyNameMatching'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.CompanyNameMatching' {
        return 'Toolbox.CompanyNameMatching'
    }

    static get __baseType(): 'Toolbox.CompanyNameMatching' {
        return 'Toolbox.CompanyNameMatching'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.CompanyNameMatching' {
        return 'Toolbox.CompanyNameMatching'
    }

    get [BoInfoSymbol]() {
        return Toolbox__CompanyNameMatching[BoInfoSymbol]
    }

    get resolutions(): Toolbox.CompanyNameResolution[] {
        return this.θresolutions?.()
    }

    set resolutions(resolutions) {
        this.θresolutions.set(LowgileDataUtil.coerceDataType(resolutions, Toolbox.CompanyNameResolution, true, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__CompanyNameMatching>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                resolutions: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__CompanyNameMatching()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__CompanyNameMatching>, restrictToClass?: Class<Partial<Toolbox__CompanyNameMatching>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            get resolutions() { return z.array(Toolbox.CompanyNameResolution.$getSchema()) },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__CompanyNameMatching.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []

        names.push('resolutions', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    static async executeMatching(input: string, isUseAi: boolean, companyType: This.CompanyNameMatchingCompanyType): Promise<This.CompanyNameMatching> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<This.CompanyNameMatching>('Entity', 'Toolbox', 'CompanyNameMatching', undefined, 'executeMatching', args)
        return result
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__CompanyNameMatching {
        return equal(this, other)
    }
}

namespace Toolbox__CompanyNameMatching { }

export import CompanyNameMatching = Toolbox__CompanyNameMatching
setTimeout(() => {
    jsonArrayProperty(() => Toolbox.CompanyNameResolution)(Toolbox__CompanyNameMatching.prototype, 'resolutions')
    jsonProperty(() => Date)(Toolbox__CompanyNameMatching.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__CompanyNameMatching.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__CompanyNameMatching.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__CompanyNameMatching.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__CompanyNameMatching.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__CompanyNameMatching.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__CompanyNameMatching.prototype, 'versionNumber')
})
